import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../SpriteMount.js";
var symbol = new SpriteSymbol({
  "id": "ridestyler-showcase-icon-chevron-left",
  "use": "ridestyler-showcase-icon-chevron-left-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 50\" id=\"ridestyler-showcase-icon-chevron-left\"><defs><path d=\"m7.81 25 25 25 9.38-9.37L26.56 25 42.19 9.38 32.81 0l-25 25z\" id=\"ridestyler-showcase-icon-chevron-left_a\" /></defs><use xlink:href=\"#ridestyler-showcase-icon-chevron-left_a\" /><use xlink:href=\"#ridestyler-showcase-icon-chevron-left_a\" fill-opacity=\"0\" stroke=\"#000\" stroke-opacity=\"0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol